/**
 * Centralized GSAP plugin registration. Imported once from main.tsx so every
 * useGSAP() call in the app has all plugins available without re-importing.
 *
 * GSAP 3.13+ (2025-05) made ScrollTrigger / SplitText / Flip etc. free under
 * the No-Charge license; we can ship them in production without paid Club.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { Flip } from 'gsap/Flip';

if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger, SplitText, Flip);

  // Sensible defaults — feels "premium" without per-call config.
  gsap.defaults({
    ease: 'expo.out',
    duration: 0.7,
  });

  // Refresh on font load — SplitText needs metrics that aren't ready until
  // web fonts hit the page.
  if ('fonts' in document) {
    void document.fonts.ready.then(() => ScrollTrigger.refresh());
  }
}

export { gsap, ScrollTrigger, SplitText, Flip };
